import React,{useCallback,useEffect,useMemo,useState} from 'react';
import {CASHIER_CAPABILITIES} from './deviceOperatorPolicy.js';
import {pilotDeviceStateLabel} from './pilotDeviceStatus.js';

const CASA='aa40691b-a6bf-4622-8c51-a515e2345005';
const CONSERT='c4ed5f2b-ff91-4f3b-ba0f-1b40ce585e5b';
const labels={
 pdv_presale:'Criar e consultar pré-vendas',pdv_sell:'Registrar vendas (após homologação)',
 pdv_register:'Abrir e fechar caixa',pdv_customers:'Clientes',
 pdv_catalog:'Cadastrar produtos',pdv_inventory:'Estoque',
 pdv_cash_management:'Sangrias e suprimentos',
 pdv_reports:'Relatórios gerenciais',pdv_audit:'Histórico e auditoria',
 pdv_void_sales:'Estornar vendas',pdv_discount_override:'Liberar descontos',
 pdv_negative_stock_checkout:'Estoque negativo (quando permitido)'
};
const presets=[
 {name:'Cadastro e conferência',caps:['pdv_presale','pdv_catalog','pdv_inventory']},
 {name:'Caixa',caps:['pdv_presale','pdv_sell','pdv_register']},
 {name:'Consulta',caps:['pdv_presale']},
 {name:'Supervisor',caps:['pdv_presale','pdv_sell','pdv_register','pdv_void_sales','pdv_reports']},
];
function Checks({value,onChange,prefix}){
 return <div className="staffChecks">
 {CASHIER_CAPABILITIES.map(cap=><label className="staffToggle" key={cap}>
  <input type="checkbox" checked={value.includes(cap)}
   onChange={e=>onChange(e.target.checked?[...value,cap]:value.filter(c=>c!==cap))}
   id={prefix+cap}/>
  <span>{labels[cap]}</span>
 </label>)}
 </div>;
}
export default function TerminalOperatorAdminPilot({accessToken,activeOrganizationId,availableOrganizations=[]}){
 const manageable=availableOrganizations.filter(item=>[CASA,CONSERT].includes(item.id));
 const initialOrg=manageable.some(item=>item.id===activeOrganizationId) ? activeOrganizationId : (manageable[0]?.id||'');
 const [org,setOrg]=useState(initialOrg),[devices,setDevices]=useState([]),[invites,setInvites]=useState([]);
 const [name,setName]=useState('Computador 1'),[type,setType]=useState('desktop');
 const [deviceCaps,setDeviceCaps]=useState(['pdv_presale']);
 const [includeCasa,setIncludeCasa]=useState(false);
 const [casaCaps,setCasaCaps]=useState(['pdv_presale']);
 const [email,setEmail]=useState(''),[employeeCaps,setEmployeeCaps]=useState(['pdv_presale']);
 const [assigned,setAssigned]=useState([]);
 const [working,setWorking]=useState(false),[notice,setNotice]=useState(''),[managerReady,setManagerReady]=useState(false);
 const [pairCode,setPairCode]=useState(null);
 const api=useCallback(async(resource,payload)=>{
  if(!accessToken)throw Error('É necessário entrar com login individual.');
  const base='/internal/smartpdv/pilot/admin/'+resource;
  const path=payload?base:base+'?organization_id='+encodeURIComponent(org);
  const response=await fetch(path,{method:payload?'POST':'GET',
   headers:{authorization:'Bearer '+accessToken,
    ...(payload?{'content-type':'application/json'}:{})},
   cache:'no-store',credentials:'same-origin',
   ...(payload?{body:JSON.stringify({...payload,organization_id:org})}:{})});
  const data=await response.json().catch(()=>({}));
  if(!response.ok){
   if(response.status===403)throw Error('Sem autorização de gestão nesta empresa. Solicite permissão ao proprietário.');
   if(response.status===503)throw Error('Cadastro protegido ainda não foi habilitado no preview.');
   throw Error(data.error||'Falha de comunicação');
  }
  return data;
 },[accessToken,org]);
 const load=useCallback(async()=>{
  if(!accessToken){setDevices([]);setInvites([]);setManagerReady(false);return;}
  setNotice('');
  try{
   const [ds,ins]=await Promise.all([api('devices'),api('invitations')]);
   setDevices(ds.entries||[]);setInvites(ins.entries||[]);setManagerReady(true);
  }catch(e){setDevices([]);setInvites([]);setManagerReady(false);setNotice(e.message);}
 },[api,accessToken]);
 useEffect(()=>{load()},[load]);
 async function perform(resource,data,success){
  setWorking(true);setNotice('');
  try{
   await api(resource,data);
   setNotice(success);await load();
  }catch(e){setNotice(e.message)}
  finally{setWorking(false)}
 }
 async function pairing(action,deviceId){
  setWorking(true);setNotice('');setPairCode(null);
  try{
   const r=await fetch('/internal/smartpdv/pilot/device/pair',{
    method:'POST',credentials:'same-origin',cache:'no-store',
    headers:{authorization:'Bearer '+accessToken,'content-type':'application/json'},
    body:JSON.stringify({action,device_id:deviceId})});
   const data=await r.json().catch(()=>({}));
   if(!r.ok)throw Error(data.error||'Operação não autorizada');
   if(action==='issue')setPairCode({device_id:deviceId,code:data.code,ttl:data.expires_in_seconds});
   else setNotice('Terminal revogado. O vínculo do navegador foi invalidado no servidor.');
   await load();
  }catch(e){setNotice(e.message)}finally{setWorking(false)}
 }
  const eligibleDevices=useMemo(()=>devices.filter(d=>d.state==='pending_pairing'),[devices]);
 async function registerDevice(e){
  e.preventDefault();
  if(!manageable.some(item=>item.id===org)){setNotice('Selecione uma empresa autorizada.');return;}
  const scopes=[{organization_id:org,capabilities:deviceCaps}];
  if(includeCasa&&manageable.length>1&&org!==CASA)scopes.push({organization_id:CASA,capabilities:casaCaps});
  if(includeCasa&&manageable.length>1&&org===CASA)scopes.push({organization_id:CONSERT,capabilities:casaCaps});
  await perform('devices',{action:'create_draft',name,device_type:type,scopes},
   'Terminal cadastrado como pendente de pareamento. Nenhum dispositivo recebeu acesso ativo.');
 }
 async function invite(e){
  e.preventDefault();
  if(!manageable.some(item=>item.id===org)){setNotice('Selecione uma empresa autorizada.');return;}
  await perform('invitations',{action:'request_invite',email,
   capabilities:employeeCaps,terminal_ids:assigned},
   'Pedido de convite registrado. Conta e permissões permanecem pendentes de aprovação.');
 }
 return <section className="panel" aria-label="Terminais e usuários SmartPDV">
  <h2>Terminais e operadores</h2>
  <p>Organize computadores, celulares e funcionários sem compartilhar contas.
  Esta gestão prepara acesso e permissões de pré-venda; não libera vendas fiscais ou pagamentos.</p>
  <p className="pilotCompanyContext" role="status">
    Empresa da operação: <strong>{availableOrganizations.find(item=>item.id===activeOrganizationId)?.name||'Não identificada'}</strong>.
    Permissões abaixo serão atribuídas exclusivamente à empresa selecionada.
  </p>
  <label>Empresa<select value={org} onChange={e=>{
   setOrg(e.target.value);setIncludeCasa(false);setAssigned([]);
  }}>
   {manageable.map(item=><option value={item.id} key={item.id}>{item.name}</option>)}
  </select></label>
  {notice&&<p role="status">{notice}</p>}
  {!managerReady?<p role="alert">Gestão não habilitada para esta empresa ou recurso ainda indisponível.</p>:
  <div className="columns">
   <section>
    <h3>Cadastrar equipamento</h3>
    <form onSubmit={registerDevice}>
     <label>Nome do terminal<input required minLength={3} maxLength={60} value={name}
      onChange={e=>setName(e.target.value)} placeholder="Computador 1"/></label>
     <label>Tipo de dispositivo<select value={type} onChange={e=>setType(e.target.value)}>
      <option value="desktop">Computador de mesa</option>
      <option value="laptop">Notebook</option>
      <option value="phone">Celular</option>
      <option value="tablet">Tablet</option>
      <option value="other">Outro</option>
     </select></label>
     <p>Perfil de permissões no terminal</p>
     <div className="pilotPresetGroup" aria-label="Perfis de permissões para este terminal">
       {presets.map(p=><button key={p.name} className={deviceCaps.join('|')===p.caps.join('|')?'selected':''} aria-pressed={deviceCaps.join('|')===p.caps.join('|')} type="button"
         onClick={()=>setDeviceCaps([...p.caps])}>{p.name}</button>)}</div>
     <Checks value={deviceCaps} onChange={setDeviceCaps} prefix="terminal-"/>
     <label className="pilotMulticompany"><input type="checkbox" disabled={manageable.length<2} checked={includeCasa}
      onChange={e=>setIncludeCasa(e.target.checked)}/> Mesmo dispositivo também atenderá
      {org===CASA?' a ConsertCell':' a Casa da Limpeza'} (requer autorização nas duas empresas)</label>
     {includeCasa&&<><p>Permissões na segunda empresa</p>
      <Checks value={casaCaps} onChange={setCasaCaps} prefix="other-org-"/></>}
     <button type="submit" disabled={working}>Salvar terminal para pareamento</button>
    </form>
    <h3>Terminais preparados</h3>
    {pairCode&&<aside aria-label="Código temporário" className="pilotPanel">
     <strong>Código de pareamento — exibição única</strong>
     <p>Terminal: <code>{pairCode.device_id}</code></p>
     <p><code>{pairCode.code}</code></p>
     <p>Válido por até 8 minutos. Copie o ID e o código no navegador do equipamento.
      Não envie por grupos públicos.</p>
     <button type="button" onClick={()=>setPairCode(null)}>Ocultar código</button>
    </aside>}
    {devices.length===0?<p>Nenhum terminal cadastrado.</p>:devices.map(d=>
     <article key={d.id} className="pilotDeviceEntry">
      <strong>{d.name}</strong> · {d.device_type}
      <small>{pilotDeviceStateLabel(d.state)}</small>
      <small>Permissões: {(d.capabilities||[]).map(c=>labels[c]||c).join(', ')||'Nenhuma'}</small>
      {['pending_pairing','active'].includes(d.state)&&<button type="button" disabled={working}
       onClick={()=>pairing('issue',d.id)}>Gerar código temporário</button>}
      {['pending_pairing','active'].includes(d.state)&&<button type="button" disabled={working}
       onClick={()=>pairing('revoke',d.id)}>Revogar dispositivo</button>}
      {d.state==='pending_pairing'&&<button type="button" disabled={working}
       onClick={()=>perform('devices',{action:'add_company',device_id:d.id,
        target_org_id:org===CASA?CONSERT:CASA,capabilities:casaCaps},
        'Solicitação de segunda empresa registrada; o terminal continua pendente de pareamento.')}>
        Adicionar {org===CASA?'ConsertCell':'Casa da Limpeza'} ao mesmo equipamento
      </button>}
     </article>)}
   </section>
   <section>
    <h3>Criar acesso de funcionário</h3>
    <p>Primeiro registre o convite. A ativação exige login próprio e autorização da empresa.</p>
    <form onSubmit={invite}>
     <label>E-mail individual<input type="email" required value={email}
      onChange={e=>setEmail(e.target.value)} placeholder="funcionario@empresa.com"/></label>
     <p>Permissões solicitadas</p>
     <div className="pilotPresetGroup" aria-label="Perfis de permissões do funcionário">
       {presets.map(p=><button key={p.name} className={employeeCaps.join('|')===p.caps.join('|')?'selected':''} aria-pressed={employeeCaps.join('|')===p.caps.join('|')} type="button"
         onClick={()=>setEmployeeCaps([...p.caps])}>{p.name}</button>)}</div>
     <Checks value={employeeCaps} onChange={setEmployeeCaps} prefix="employee-"/>
     <p>Restringir a terminais (opcional)</p>
     {eligibleDevices.map(d=><label key={d.id}>
      <input type="checkbox" checked={assigned.includes(d.id)}
       onChange={e=>setAssigned(current=>e.target.checked?[...current,d.id]:current.filter(x=>x!==d.id))}/>
      {d.name}
     </label>)}
     <button type="submit" disabled={working}>Salvar solicitação de convite</button>
    </form>
    <h3>Convites pendentes</h3>
    {invites.length===0?<p>Não há solicitações nesta empresa.</p>:invites.map(i=>
     <article key={i.id} className="pilotDeviceEntry">
      <strong>{i.email}</strong><small>{i.state==='pending_owner_review'?'Aguardando aprovação e convite':'Cancelado'}</small>
      <small>{(i.capabilities||[]).map(c=>labels[c]||c).join(', ')}</small>
     </article>)}
   </section>
  </div>}
  <p><strong>Segurança:</strong> as permissões efetivas exigirão operador autorizado + terminal pareado
   + organização habilitada. Administradores do KAIZEN e K-Repair não são criados neste painel.</p>
 </section>;
}

